import React from 'react';
import { Tabs, Background, Logo, Copyright, Download } from '../../Component';
import styles from './index.module.less';

const Center = () => {
  return (
    <div className={styles.login}>
      <Background className={styles.video} />
      <div className={styles.form}>
        <Logo className={styles.logo} />
        <div className={styles.main}>
          <Tabs className={styles.tabs} mode="center" />
          <Download className={styles.download}/>
        </div>
        <Copyright className={styles.footer} />
      </div>
    </div>
  );
};

export default Center;
